import {connect} from "react-redux";
import OrderForm from "./../component/OrderForm";
import {
    getSelectedDoctypeId,
    getSelectedLevelId,
    getSelectedUrgencyId,
    getSelectedVasIds,
    getSelectedVasItems,
    getSelectedCoverLettersCount,
    getDiscountCode,
    issetValidationErrors,
    getCountValidations
} from "../reducers";

const mapStateToProps = state => {
    return {
        selectedDoctypeId: getSelectedDoctypeId(state),
        selectedLevelId: getSelectedLevelId(state),
        selectedUrgencyId: getSelectedUrgencyId(state),
        selectedVasIds: getSelectedVasIds(state),
        selectedVasItems: getSelectedVasItems(state),
        selectedCoverLettersCount: getSelectedCoverLettersCount(state),
        discountCode: getDiscountCode(state),
        issetValidationErrors: issetValidationErrors(state),
        countValidations: getCountValidations(state),
    }
}

export default connect(
    mapStateToProps
)(OrderForm)

